<template>
  <a-modal class="date-modal-css" v-model="showModal" title="新增" width="1000px" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <a-form-model ref="baseForm" :model="formData">
      <a-row>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="材料商名称"
            prop="supplierCode"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :rules="{'required':true,'message':' ','trigger':'change'}"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <global-select
              ref="supplierCodeRef"
              :dropdown-match-select-width="false"
              :value.sync="formData.supplierCode"
              selectType="selectSearch"
              requestApi="/mdm/mdmOrgSupplier/supplierNameList"
              :selectItem="{ value: 'label', label: 'realValue' }"
              searchParam="supplierName"
              @change="supplierChange"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="角色"
            prop="roleTypeCode"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :rules="{'required':true,'message':' ','trigger':'change'}"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <global-select
              :value.sync="formData.roleTypeCode"
              :selectData="roleList"
              selectType="selectFilter"
              :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="电话"
            prop="userTel"
            :rules="{
                    'required':true,
                    'message':' ',
                    'trigger':'blur',
                    'validator':(rule,value,callback)=>{ phoneCheck(rule,value,callback)}}"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-input v-model="formData.userTel" placeholder="请输入" :maxLength="50" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="姓名"
            prop="userName"
            :rules="{'required':true,'message':' ','trigger':'blur'}"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-input v-model="formData.userName" placeholder="请输入" :maxLength="50" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="可否操作异常备注"
            prop="enableExceptionRemark"
            :rules="{'required':true,'message':' ','trigger':'blur'}"
            :labelCol="{ style: 'width: 130px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 130px) !important;float:left'}"
          >
            <a-select v-model="formData.enableExceptionRemark" :allowClear="false">
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0">否</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <div class="footer-btn-wrapper">
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" :loading="loading" @click="onSubmit">确认</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import { apiRoleSaveOrUpdate } from '@/api/scp/materialReservationManagement/materialReservation'
export default {
  name: 'AddRoleModal',
  data () {
    return {
      loading: false,
      showModal: false,
      formData: {
        userName: undefined, // 用户名
        roleTypeCode: undefined, // 角色快码
        userTel: undefined, // 电话
        supplierCode: undefined, // 供应商编码
        supplierName: undefined, // 供应商名称
        enableExceptionRemark: 0 // 是否可操作异常备注
      }
    }
  },
  props: {
    roleList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  methods: {
    // 校验电话是否都为数字
    phoneCheck(rule, value, callback) {
      if(!/^[0-9]+$/.test(value)) {
        // eslint-disable-next-line standard/no-callback-literal
        return callback(' ')
      }
      return callback()
    },
    // 展示
    show() {
      this.reset()
      this.showModal = true
    },
    // 材料商选择回调
    supplierChange(val, data) {
      if(val) {
        const getSupplier = data?.find(item => item?.label === val)
        this.formData.supplierName = getSupplier?.realValue
      } else {
        this.formData.supplierName = ''
      }
    },
    // 取消
    onCancel() {
      this.showModal = false
    },
    // 重置
    reset() {
      this.formData = {
        userName: undefined, // 用户名
        roleTypeCode: undefined, // 角色快码
        userTel: undefined, // 电话
        supplierCode: undefined, // 供应商编码
        supplierName: undefined, // 供应商名称
        enableExceptionRemark: 0 // 是否可操作异常备注
      }
    },
    // 提交
    onSubmit() {
      if(!this.organizationCodeOrigin) {
        this.$message.warning('未找到组织')
        return
      }
      this.$refs.baseForm.validate(valid => {
        if(valid) {
          const organizationName = this.inventOrg?.find(item => item?.realValue === this.organizationCodeOrigin)?.label
          const params = {
            ...this.formData,
            organizationNo: this.organizationCodeOrigin,
            organizationName: organizationName
          }
          this.loading = true
          apiRoleSaveOrUpdate(params).then(res => {
            if (res?.code === 200) {
              this.$message.success('新增成功')
              this.$emit('refreshFun')
              this.showModal = false
            }
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.$message.warning('请检查必填项')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
